import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudSimpleDisconnected: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCloudSimpleDisconnected"><Path d="M6.5 19.1085C3.59316 18.1082 1.5 15.3036 1.5 12C1.5 7.85786 4.79071 4.5 8.85 4.5C11.8837 4.5 14.4881 6.37545 15.6105 9.05211C16.1263 8.87923 16.6775 8.78571 17.25 8.78571C20.1495 8.78571 22.5 11.1842 22.5 14.1429C22.5 17.016 20.2834 19.3609 17.5 19.494" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 15.5L12 18M12 18L9.5 20.5M12 18L9.5 15.5M12 18L14.5 20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCloudSimpleDisconnected;
